import React from 'react';
import { useTheme } from '../context/ThemeContext';

function Footer() {
  const { isDark } = useTheme();
  
  return (
    <footer className="w-full mt-0">
      <div className="max-w-6xl mx-auto">
        <div className={`flex justify-center items-center space-x-4 px-8 py-3 ${isDark ? 'bg-hack-secondary/50' : 'bg-white'}`}>
          <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-700'}`}>
            {new Date().getFullYear()} HackBench
          </p>
          <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-700'}`}>·</span>
          <a href="#" 
             className={`text-sm hover:underline ${isDark ? 'text-gray-400' : 'text-gray-700'}`}>
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
